module.exports = __webpack_public_path__ + "img/Silver-Square.5e304fb4.png";